import {
  updateCanRunExtension,
  updateExtensionInstalled,
} from 'actions/device';
import * as extension from 'utilities/extension';

export function installExtensionCreator(source) {
  return dispatch => {
    return new Promise(resolve => {
      extension.inlineInstall(source, () => {
        dispatch(updateExtensionInstalled(true));

        resolve();
      });
    });
  };
}

export function extensionInstalledCreator() {
  return async dispatch => {
    const isInstalled = await new Promise(resolve =>
      extension.isInstalled(resolve)
    );

    if (isInstalled) {
      return dispatch(updateExtensionInstalled(true));
    }

    return dispatch(updateExtensionInstalled(false));
  };
}

export function extensionCanRunCreator() {
  return dispatch => {
    return dispatch(updateCanRunExtension(extension.canRunExtension));
  };
}
